import { Paper, Box, Typography } from '@mui/material';
import { TrendingUp, TrendingDown, TrendingFlat } from '@mui/icons-material';

interface Props {
  icon: React.ReactNode;
  label: string;
  value: string;
  accentColor: string;
  change?: number | null;
  changeLabel?: string;
  onClick?: () => void;
}

const KPICard = ({ icon, label, value, accentColor, change, changeLabel, onClick }: Props) => {
  const isPositive = change !== null && change !== undefined && change > 0;
  const isNegative = change !== null && change !== undefined && change < 0;
  const changeColor = isPositive ? '#16a34a' : isNegative ? '#dc2626' : '#94a3b8';

  return (
    <Paper
      elevation={0}
      onClick={onClick}
      sx={{
        p: 0,
        borderRadius: 3,
        display: 'flex',
        alignItems: 'stretch',
        cursor: onClick ? 'pointer' : 'default',
        border: '1px solid #e5e7eb',
        background: '#fff',
        transition: 'all 0.15s ease',
        overflow: 'hidden',
        '&:hover': onClick ? {
          borderColor: accentColor,
          boxShadow: `0 4px 12px ${accentColor}15`,
          transform: 'translateY(-1px)',
        } : {},
      }}
    >
      <Box sx={{ width: 4, bgcolor: accentColor, flexShrink: 0 }} />
      <Box sx={{ p: 2, flex: 1, minWidth: 0, height: 110, display: 'flex', flexDirection: 'column', justifyContent: 'space-between' }}>
        <Box display="flex" alignItems="center" justifyContent="space-between" mb={1}>
          <Typography sx={{ fontSize: '0.75rem', fontWeight: 600, color: '#64748b', letterSpacing: '0.02em' }}>
            {label}
          </Typography>
          <Box sx={{
            width: 32, height: 32, borderRadius: '8px',
            bgcolor: `${accentColor}10`,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            color: accentColor,
            '& svg': { fontSize: 18 },
          }}>
            {icon}
          </Box>
        </Box>

        <Typography sx={{ fontSize: '1.5rem', fontWeight: 800, color: '#0f172a', letterSpacing: '-1px', lineHeight: 1.2, mb: 0.5 }}>
          {value}
        </Typography>

        {change !== null && change !== undefined && (
          <Box display="flex" alignItems="center" gap={0.5}>
            {isPositive ? <TrendingUp sx={{ fontSize: 14, color: changeColor }} /> :
             isNegative ? <TrendingDown sx={{ fontSize: 14, color: changeColor }} /> :
             <TrendingFlat sx={{ fontSize: 14, color: changeColor }} />}
            <Typography sx={{ fontSize: '0.7rem', fontWeight: 600, color: changeColor }}>
              {isPositive ? '+' : ''}{change}%
            </Typography>
            {changeLabel && (
              <Typography sx={{ fontSize: '0.65rem', color: '#94a3b8' }}>
                {changeLabel}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Paper>
  );
};

export default KPICard;
